import { useState } from 'react';

/** `await fetch(() => ...)`されている間はisLoadingがtrueになる */
export function useFetch() {
  const [isLoading, setIsLoading] = useState(false);
  const [isError, setIsError] = useState(false);

  const fetch = async <T>(fn: () => Promise<T>) => {
    setIsError(false);
    setIsLoading(true);
    const result = await fn()
      .catch((e) => {
        setIsError(true);
        throw new Error('useFetch error', { cause: e });
      })
      .finally(() => setIsLoading(false));

    return result;
  };

  return { fetch, isLoading, isError };
}
